import * as Actions from "store/actions/app/branches.actions"

const initialState = {
  loading_branches: false,
  branches: []
}

const branchesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_BRANCHES: {
      return {
        ...state,
        loading_branches: action.payload.loading ?? state.loading_branches,
        branches: action.payload.data ?? state.branches
      }
    }
    default: {
      return state
    }
  }
}
export default branchesReducer
